import type ApiContent from 'src/core/models/api/ApiContent';

export const exerciseOpensInDialog = (exercise: ApiContent): boolean => exercise.is_youtube_url === true;
